/**************************************************************************************************/
/*   File: /src/app/shared/enums/document.status.enum.ts                                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The document status enum
 */
export enum DocumentStatusEnum {
    /**
     * The document file exists
     */
    EXISTS = 1,
    /**
     * The document file not exists
     */
    NOT_EXISTS = 2
}